import { Outlet } from 'react-router'
import { Logo } from './Logo'

export function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-gray-50 pt-safe pb-safe">
      <main className="flex flex-1 items-center justify-center p-4">
        <div className="w-full max-w-sm">
          <div className="mb-8 flex justify-center">
            <Logo size="lg" />
          </div>
          <Outlet />
        </div>
      </main>
    </div>
  )
}
